Vue.component('search-filter', {
    props: {
        data: Array,
        title: String,
        properties: {
            type: Object,
            default: function () {
                return {
                    reset: false,
                    allChecked: false,
                    unselectAll: false
                }
            }
        },
        filterTag: String,
        availableData: Array
    },
    data: function(){
        return{
            reset: FmtMessage.getMessage("js.search.filter.reset") ? FmtMessage.getMessage("js.search.filter.reset") : 'reset',
            unselect: FmtMessage.getMessage("js.search.filter.uncheckAll") ? FmtMessage.getMessage("js.search.filter.uncheckAll") : 'uncheck all',
            tag: this.filterTag ? this.filterTag : 'text' ,
            filters: [],
            appliedFilters: [],
        }
    },
    created: function(){
        this.resetFilter();
    },
    computed: {
        resetable: function () {

            if (!this.properties.reset){
                return false;
            }

            if (this.properties.allChecked && this.appliedFilters.length != this.filters.length){
                return true;
            }
            else if(!this.properties.allChecked && this.appliedFilters.length > 0){
                return true;
            }
            return false;
        }
    },
    methods: {
        resetFilter: function () {
            var vm = this;

            this.filters = this.data.map(function (item) {

                item.value = item.value ? item.value : vm.properties.allChecked;

                return item;
            });

            this.appliedFilters = [];


            this.appliedFilters = this.filters
                .filter(function (item) {
                    return item.value;
                })
                .map(function (item) {
                return item[vm.tag];
            });

            this.$emit('input', this.appliedFilters)
        },
        unselectAll: function () {
            this.filters.forEach(function (item) {
                item.value = false;
            });
        },
        applyFilter: function(filter){

            this.filters.forEach(function (item) {
                if (item.text == filter.text){
                    item.value = !item.value;
                }
            });

            if (this.appliedFilters.includes(filter[this.tag])){
                var index = this.appliedFilters.indexOf(filter[this.tag]);
                this.appliedFilters.splice(index, 1);
            }
            else {
                this.appliedFilters.push(filter[this.tag])
            }
            this.$emit('input', this.appliedFilters)
        }

    },
    watch: {
        data: {
            handler: function() {
                this.resetFilter();
            },
            deep: true
        },
        availableData: {
            handler: function(data) {
                this.filters.forEach(function (item) {
                    if (data.includes(item.text)){
                        item.value = true;
                    }
                    else {
                        item.value = false;
                    }
                })
            },
            deep: true,
        }
    },

    template: '\<li class="filter-section-title">\
				<h2>\
					{{title}} <a v-if="resetable" @click="resetFilter" class="sf-reset">{{reset}}</a>\
				</h2>\
				<a  v-if="properties.unselectAll" @click="unselectAll" class="sf-reset btn btn-link">{{unselect}}</a>\
				<ul id="busfirmlist">\
					<li v-for="(filter, index) in filters" :key="filter.text">\
						<label>\
							<input  type="checkbox" v-model="filter.value"  class="" @click="applyFilter(filter)"/> {{filter.text}}\
						</label>\
					</li>\
				</ul>\
			</li>\
        ',


});


